export var searchCenterUrlKey = '-searchcenterurl';
//# sourceMappingURL=constants.js.map